import { render, staticRenderFns } from "./distribution-pattern.vue?vue&type=template&id=528e1090&scoped=true"
import script from "./distribution-pattern.vue?vue&type=script&lang=ts"
export * from "./distribution-pattern.vue?vue&type=script&lang=ts"
import style0 from "./distribution-pattern.vue?vue&type=style&index=0&id=528e1090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e1090",
  null
  
)

export default component.exports